import { useSellerStore } from "../../lib/store/seller-store";

// The red "Debug" pill (tester feedback), shared by the directory's rail and the talent
// page's top bar. A global tester setting, not tied to a talent (`store.debugMode`).
export function DebugToggle() {
  const debugMode = useSellerStore((s) => s.debugMode);
  const setDebugMode = useSellerStore((s) => s.setDebugMode);
  return (
    <button
      type="button"
      className={`sl-debug-toggle${debugMode ? " sl-debug-toggle--on" : ""}`}
      onClick={() => setDebugMode(!debugMode)}
      aria-pressed={debugMode}
      title={
        debugMode
          ? "Debug mode ON. Log feedback notes for the team. Click to turn off."
          : "Turn on debug mode: log feedback notes for the team."
      }
    >
      <span className="sl-debug-toggle__dot" aria-hidden="true" />
      <span className="sl-rail__label">Debug</span>
    </button>
  );
}
